import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=64214a47&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=64214a47&scoped=true&lang=css"
import style1 from "./DetailsModal.vue?vue&type=style&index=1&id=64214a47&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64214a47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64214a47')) {
      api.createRecord('64214a47', component.options)
    } else {
      api.reload('64214a47', component.options)
    }
    module.hot.accept("./DetailsModal.vue?vue&type=template&id=64214a47&scoped=true", function () {
      api.rerender('64214a47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/components/configurationCopy/modais/DetailsModal.vue"
export default component.exports